import { useTranslation } from "react-i18next";
import { TrendingDown, Wallet, Scale } from "lucide-react";
import { useScrollFadeIn, fadeCls, fadeStyle } from "@/hooks/useScrollFadeIn";

export default function RelarkRoiSnippet() {
  const { t } = useTranslation("ui");
  const { ref, isVisible } = useScrollFadeIn();

  const stats = [
    { icon: TrendingDown, num: 1 },
    { icon: Wallet, num: 2 },
    { icon: Scale, num: 3 },
  ];

  return (
    <section className="bg-accent/30 py-16 sm:py-24">
      <div ref={ref} className="mx-auto max-w-5xl px-5">
        <div className={`text-center max-w-2xl mx-auto ${fadeCls(isVisible)}`}>
          <h2 className="text-2xl font-bold sm:text-3xl">{t("relark.roi.title")}</h2>
          <p className="mt-3 text-muted-foreground leading-relaxed">
            {t("relark.roi.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {stats.map(({ icon: Icon, num }, idx) => (
            <div
              key={num}
              className={`rounded-2xl border border-border bg-card p-6 ${fadeCls(isVisible)}`}
              style={fadeStyle(idx * 100)}
            >
              <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                <Icon className="h-5 w-5 text-primary" />
              </div>
              <p className="text-xs uppercase tracking-wider text-muted-foreground font-semibold">
                {t(`relark.roi.stat${num}Label`)}
              </p>
              <p className="mt-2 text-2xl font-bold text-primary">
                {t(`relark.roi.stat${num}Value`)}
              </p>
              <p className="mt-3 text-xs text-muted-foreground leading-relaxed">
                {t(`relark.roi.stat${num}Source`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
